import Wishlist from '../Account/Wishlist';
export default Wishlist;
